import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import { ROUTE_SIGNAL } from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import {
  getSharedSignalsByCurrentMember,
  getSignalSharedByCurrentMember,
  shareSignalWithMember,
} from '../../../../services/store/modules/signal';
import { SignalShare } from '../../../../services/store/modules/signal/models';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import UserLookup, { UserSearchResult } from '../components/UserLookup';

export const filterSearchResults = (
  matches: UserSearchResult[],
  currentMemberId: string | undefined,
  alreadySharedSignals: SignalShare[],
): UserSearchResult[] =>
  matches
    .filter((match) => match.id !== currentMemberId)
    .filter(
      (match) =>
        !alreadySharedSignals.find(
          (sharedSignal) => sharedSignal.sharedWith.id === match.id,
        ),
    );

const SignalAddSharedUsersPage: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const alreadySharedSignals = useSelector(getSignalSharedByCurrentMember);

  const filterMatches = (
    matches: UserSearchResult[],
    currentMemberId: string | undefined,
  ) => filterSearchResults(matches, currentMemberId, alreadySharedSignals);

  useEffect(() => {
    dispatch(getSharedSignalsByCurrentMember());
  }, [dispatch]);

  const handleBack = async () => {
    await captureEvent({
      type: 'signal: back to activate signal',
      payload: {},
      sendToAmplitude: true,
    });

    history.goBack();
  };

  const handleSelectShare = async (memberId: string) => {
    await captureEvent({
      type: 'signal: add share contact',
      payload: {
        memberId,
      },
      sendToAmplitude: true,
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore unwrap() is required so that the error is thrown correctly.
    await dispatch(shareSignalWithMember(memberId)).unwrap();

    // Redirect back to signal share list page
    transitionToNextRoute(ROUTE_SIGNAL);
  };

  return (
    <BasicDrawerLayout
      onBack={handleBack}
      heading="Select contact"
      showMenuBar={false}
    >
      <UserLookup
        onSelectUser={handleSelectShare}
        filterSearchResults={filterMatches}
      />
    </BasicDrawerLayout>
  );
};

export default SignalAddSharedUsersPage;
